import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import AuthLayout, { Field } from "./AuthLayout";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      toast.success(data.message || "Password updated");
      nav("/login");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    setLoading(false);
  };

  return (
    <AuthLayout title="Choose a new password" subtitle="Enter a new password for your account"
      footer={<Link to="/login" className="text-blue-accent font-semibold">← Back to sign in</Link>}>
      {!token ? (
        <p className="text-red-600">This reset link is invalid. Please request a new one.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <Field label="New password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" placeholder="At least 6 characters" />
          <button disabled={loading} data-testid="reset-submit" className="w-full px-5 py-3 rounded-xl bg-navy hover:bg-slate-800 text-white font-semibold transition-colors disabled:opacity-60">
            {loading ? "Updating…" : "Update password"}
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
